import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { SeFeFormService } from 'se-fe-form-service'
import { SeFeToastService } from 'se-fe-toast'

const exampleHtml = `
<div *ngIf="form">
  <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <se-po-email
      seFeDataLabel="Email"
      formControlName="email">
    </se-po-email>
    <div class="form-submit">
      <se-fe-button
        seFeDataEmphasis="high"
        seFeDataType="submit">
        Submit
      </se-fe-button>
    </div>
  </form>
  <div class="form-value">
    <code>
      {{ form.value | json }}
    </code>
  </div>
</div>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { SeFeFormService } from 'se-fe-form-service'
import { SeFeToastService } from 'se-fe-toast'

export class EmailExampleComponent implements OnInit {
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder,
    private formService: SeFeFormService,
    private seFeToastService: SeFeToastService
  ) { }

  public ngOnInit(): void {
    this.form = this.fb.group({
      email: ''
    })
  }

  public submit(): void {
    const valid = this.formService.isValid(this.form)
    if (!valid) {
      console.log('validation failed')
      console.log(this.form)
    } else {
      this.seFeToastService.success('Submitted form')
    }
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-email-example',
  template,
  styleUrls: ['./email-docs.component.scss'],
  standalone: false,
})
export class EmailExampleComponent extends SeFeDocsExampleComponent implements OnInit, OnDestroy {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder,
    private formService: SeFeFormService,
    private seFeToastService: SeFeToastService
  ) {
    super()
  }

  public ngOnInit(): void {
    this.form = this.fb.group({
      email: ''
    })
  }

  public ngOnDestroy(): void {
    this.seFeToastService.events.next(undefined)
  }

  public submit(): void {
    const valid = this.formService.isValid(this.form)
    if (!valid) {
      console.log('validation failed')
      console.log(this.form)
    } else {
      this.seFeToastService.success('Submitted form')
    }
  }
}
